import React, { useState } from 'react';
import { updateDoc, doc } from 'firebase/firestore';
import { auth, db } from '../../firebase';

const PhoneVerificationModal = ({ isOpen, onClose, onSuccess, user }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  // Função para formatar telefone
  const formatPhone = (phone) => {
    return phone
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  };

  const handlePhoneChange = (e) => {
    setPhoneNumber(formatPhone(e.target.value));
    setPhoneError('');
  };

  const handleSavePhone = async () => {
    if (!phoneNumber) {
      setPhoneError('Por favor, informe seu número de WhatsApp.');
      return;
    }

    const rawPhone = phoneNumber.replace(/\D/g, '');
    if (rawPhone.length < 10) {
      setPhoneError('Por favor, informe um número válido com DDD.');
      return;
    }

    setLoading(true);

    try {
      const currentUser = user || auth.currentUser;
      if (currentUser) {
        await updateDoc(doc(db, 'users', currentUser.uid), {
          phone: phoneNumber,
          updatedAt: new Date()
        });
        
        if (onSuccess) {
            onSuccess();
        } else {
            onClose();
        }
      } else {
          setPhoneError('Usuário não identificado.');
      }
    } catch (error) {
      console.error('Erro ao salvar telefone:', error);
      setPhoneError('Erro ao salvar o número. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
          <div>
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100">
              <svg className="h-6 w-6 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <div className="mt-3 text-center sm:mt-5">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                Número de WhatsApp Obrigatório
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  Para continuar, precisamos do seu número de WhatsApp para contato.
                </p>
              </div>
              <div className="mt-4">
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  placeholder="(00) 00000-0000"
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-gray-900"
                />
                {phoneError && (
                  <p className="mt-2 text-sm text-red-600">
                    {phoneError}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="mt-5 sm:mt-6">
            <button
              type="button"
              onClick={handleSavePhone}
              disabled={loading}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:opacity-50"
            >
              {loading ? 'Salvando...' : 'Confirmar e Continuar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneVerificationModal;
